import t from"react";import{MdIcon as o}from"./MdIcon.js";import{mdiInformationOutline as i}from"@mdi/js";const r=({id:r="info",title:e="Info",...m})=>t.createElement(o,{id:r,title:e,path:i,...m});export{r as InfoIcon};
